<template>
  <v-card flat class="grey-background">
    <v-card-text>
      <div class="custom-font-semi-bold custom-text text-grey">Acción a cumplimentar</div>
      <div class="custom-font-regular custom-text text-grey">{{ requerimiento.descripcion }}</div>
      <div v-if="hasTextField">
        <hr class="dotted-hr hr-margin-top">
        <v-flex xs12>
          <RequerimientoTextField ref="textField" :requerimiento="requerimiento"></RequerimientoTextField>
        </v-flex>
      </div>
      <div v-else><NullTextField ref="textField"></NullTextField></div>
      <div v-if="requerimiento.hasAdjuntos">
        <hr class="dotted-hr">
        <div class="custom-font-semi-bold custom-text text-grey">Archivos asociados</div>
        <component :is="attachments" ref="attachments" :requerimiento="requerimiento" :is-ficha="isFicha"
                   :impacts-repo="impactsRepo"></component>
      </div>
      <div v-else><NullAttachments ref="attachments"></NullAttachments></div>
      <div v-if="showObservaciones">
        <hr class="dotted-hr hr-margin-top">
        <div class="custom-font-semi-bold custom-text text-grey">Observaciones</div>
        <RequerimientoObservaciones @updateRequerimiento="updateAfterRequest"
                                    ref="observacion"
                                    :requerimiento="requerimiento">
        </RequerimientoObservaciones>
      </div>
      <div v-else><NullObservaciones ref="observacion"></NullObservaciones></div>
      <div>
        <hr class="dotted-hr hr-margin-top" v-if="$store.getters.isClubRole">
        <div v-if="saving">
          <v-progress-linear :indeterminate="true"></v-progress-linear>
          <v-subheader class="custom-font-regular">Guardando requerimiento, por favor espere.</v-subheader>
        </div>
        <v-card-title v-if="isFicha && requerimiento.hasAdjuntos" class="custom-message">
          <div>Asegurese de que los adjuntos correspondan a la actualización que está realizando, elimine todos los adjuntos que no correspondan a la version final deseada.</div>
          <div>Los adjuntos que no correspondan deben ser eliminados, en el caso de caso contrario la actualización podrá ser rechazada.</div>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <template v-if="draft && !impactsRepo">
            <ConfirmationDialog ref="confirm" :function-yes="bindingFunction" text="¿Quitar requerimiento?"></ConfirmationDialog>
            <v-tooltip bottom>
              <v-btn slot="activator" icon @click="deleteRequerimiento"><v-icon>delete</v-icon></v-btn>
              <span>Borrar actualización del requerimiento</span>
            </v-tooltip>
          </template>
          <v-btn :disabled="!isModified || saving" color="#1787c9" class="submit-button white--text"
                 @click="uploadAllFiles">Guardar</v-btn>
        </v-card-actions>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { s3UploadMixin } from '../../../../mixins/s3UploadMixin'
import Constants from '../../../../common/constants'
import NullTextField from './NullTextField'
import NullAttachments from './NullAttachments'
import NullObservaciones from './NullObservaciones'
import RequerimientoTextField from './RequerimientoTextField'
import RequerimientoObservaciones from './RequerimientoObservaciones'
import RequerimientoAttachmentsNone from './RequerimientoAttachmentsNone'
import RequerimientoAttachmentsUser from './RequerimientoAttachmentsUser'
import RequerimientoAttachmentsAdmin from './RequerimientoAttachmentsAdmin'
import ConfirmationDialog from '../../../../common/ui/ConfirmationDialog'

export default {
  mixins: [s3UploadMixin],

  props: {
    requerimiento: Object,
    isFicha: Boolean,
    impactsRepo: Boolean,
    currentStatus: String,
    draft: Boolean
  },

  components: {
    NullTextField,
    NullAttachments,
    NullObservaciones,
    RequerimientoTextField,
    RequerimientoObservaciones,
    RequerimientoAttachmentsNone,
    RequerimientoAttachmentsUser,
    RequerimientoAttachmentsAdmin,
    ConfirmationDialog
  },

  data () {
    return {
      requerimientoTypes: ['Texto', 'Numérico', 'Ninguno', 'Sí/No', 'Teléfono', 'Email', 'Dirección'],
      isMounted: false,
      saving: false,
      bindingFunction: null,
      submitPath: (this.isFicha && !this.impactsRepo) || (this.isFicha && this.impactsRepo && this.$route.path === '/draft') ? 'draft/add' : 'requerimiento'
    }
  },

  computed: {
    hasTextField () {
      return this.requerimiento.tipo !== Constants.REQUERIMIENTO_ONLY_HAS_ATTACH
    },
    attachments () {
      return 'RequerimientoAttachments' + this.capitalize(this.requerimiento.allowed)
    },
    isAdminRole () {
      return this.requerimiento.allowed === 'admin'
    },
    isClubRole () {
      return this.requerimiento.allowed === 'user'
    },
    showObservaciones () {
      return (this.isAdminRole || this.isClubRole || this.hasObservaciones()) && !this.isFicha
    },
    isModified () {
      if (!this.isMounted) return false
      // Este if permite que, al editar un campo desde usuario LPF con edicion (club) pueda guardar el campo correctamente
      if (this.requerimiento.estadoDisplay === 'A Revisar' && this.$store.getters.isSafRole && this.isClubRole) {
        return this.$refs.textField.isModified() ||
             this.$refs.attachments.isModified() ||
             (this.$refs.observacion.isModified() && this.requerimiento.estadoDisplay !== 'No presentado' && this.isClubRole)
      }
      return this.isModifiedStatus() ||
             this.$refs.textField.isModified() ||
             this.$refs.attachments.isModified() ||
             (this.$refs.observacion.isModified() && this.requerimiento.estadoDisplay !== 'No presentado' && this.isClubRole)
    }
  },

  methods: {
    hasObservaciones () {
      return this.requerimiento.hasOwnProperty('observaciones') && this.requerimiento.observaciones.length
    },
    getFiles () {
      return this.$refs.attachments.getAddedFiles()
    },
    getFileInput () {
      return this.$refs.attachments.$refs.fileInput
    },
    preSubmit () {},
    isValidForm () {
      return this.$refs.textField.isValid() && this.$refs.attachments.isValid()
    },
    isModifiedStatus () {
      return (this.$store.getters.isSafRole) ? this.currentStatus !== this.requerimiento.estadoDisplay : false
    },
    updateAfterRequest (updatedRequerimiento) {
      this.$emit('updateRequerimiento', updatedRequerimiento)
    },
    getPayloadUser () {
      let payload = {}
      if (this.$refs.textField.isModified()) {
        payload.data = this.$refs.textField.getData()
      }
      if (this.assets.length > 0) {
        payload.assets = this.assets
      }
      if (this.$refs.attachments.getRemovedFiles().length > 0) {
        payload.deleted_adjuntos = this.$refs.attachments.getRemovedFiles()
      }
      if (this.isFicha && this.impactsRepo) {
        payload.add_repo = true
      }
      payload.observacion = this.$refs.observacion.getObservacion()
      return payload
    },
    getPayloadSaf () {
      let payload = {}
      if (this.$refs.textField.isModified()) {
        payload.data = this.$refs.textField.getData()
      }
      if (this.assets.length > 0) {
        payload.assets = this.assets
      }
      if (this.$refs.attachments.getRemovedFiles().length > 0) {
        payload.deleted_adjuntos = this.$refs.attachments.getRemovedFiles()
      }
      payload.attachmentChanges = this.$refs.attachments.getModifiedFiles()
      if (payload.estado == null) {
        payload.estado = this.currentStatus
      }
      if (this.isFicha && this.impactsRepo) {
        payload.add_repo = true
      }
      payload.observacion = this.$refs.observacion.getObservacion()
      payload.observacionDepartamento = this.$refs.observacion.getObservacionDepartamento()

      payload.canModifyAttachments = this.requerimiento.canModifyAttachments
      return payload
    },
    submit () {
      if (!this.isValidForm()) return
      this.saving = true
      let payload = (this.$store.getters.isSafRole) ? this.getPayloadSaf() : this.getPayloadUser()
      this.$refs.attachments.startLoading()
      this.$refs.attachments.cleanAddedFiles()
      this.$refs.attachments.cleanRemovedFiles()
      this.$refs.observacion.cleanObservacion()
      this.$refs.attachments.cleanModifiedFiles()
      this.$refs.observacion.cleanDepartamento()

      this.axios
        .put(`${this.submitPath}/${this.requerimiento.pk}`, payload)
        .then((response) => {
          this.requerimiento.isInDraft = true
          this.updateAfterRequest(response)
          this.$refs.attachments.finishLoading()
          this.saving = false
          this.postSubmit()
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
          this.saving = false
        })
    },
    deleteRequerimiento () {
      this.bindingFunction = () => {
        this.axios
          .put(`/draft/remove/${this.requerimiento.pk}`)
          .then((response) => {
            this.updateAfterRequest(response)
          })
          .catch(error => { this.$store.commit('setErrorMsg', error) })
      }
      this.$refs.confirm.openDialog()
    },
    capitalize (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
    isSaving () {
      return this.saving
    }
  },

  mounted () {
    this.isMounted = true
  }
}
</script>

<style scoped>
  .grey-background {
    background-color: #e9eaec;
  }
  .custom-font-regular {
    font-family: SourceSansProRegular, sans-serif;
  }
  .custom-font-semi-bold {
    font-family: SourceSansProSemiBold, sans-serif;
  }
  .custom-text {
    margin: 0.5em 0 0.5em 0.2em;
    font-size: 1.1em;
  }
  .text-grey {
    color: #413d3d;
  }
  .dotted-hr {
    border-top: 1px dotted darkgray;
    margin: 0 0 1.4em 0;
  }
  .hr-margin-top {
    margin-top: 1em;
  }
  .submit-button {
    padding: 0 3em 0 3em;
  }
  .custom-message {
    padding: 10px;
    font-weight: bolder;
    border: 1px solid gray;
    margin-top: 13px;
  }
</style>
